export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const FETCH_WISHLIST = 'FETCH_WISHLIST';
export const DELETE_TO_WISHLIST = 'DELETE_TO_WISHLIST';